import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import {
    Modal,
    Button,
    Input,
    InputNumber,
    Select,
    Form,
    message,
    Upload,
} from "antd";

import { PlusOutlined } from '@ant-design/icons';

const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 18, offset: 1 }
};

const buttonItemLayout = {
    wrapperCol: { span: 24, offset: 0 }
};

function FormMoudle(props:any,ref:any) {
    const [ isVisible, setIsVisible ] = useState(false);
    const [ isEdit, setIsEdit ] = useState(false);

    const [ dataList, setDataList ] = useState<any>([]);

    const [ id, setId ] = useState(0);

    const [ mainBody, setMainBody ] = useState("");
    const [ fileName, setFileName ] = useState("");

    const [forms] = Form.useForm();

    const { getValidBidInfoList, addTenderInfo, updateTenderInfo, uploadFile } = window.$axios.request;

    useEffect(() => {
        getValidBidInfoList()
        .then((res:any) => {    
            if(res.code == 1000){
                setDataList(res.data)
            }
        })
    }, []);

    useEffect(() => {
        if(!isVisible){
            forms.resetFields();
            setMainBody("");
            setFileName("");
            setIsEdit(false);
        }
    }, [ isVisible ]);

    //父组件调用子组件的方法 放在useImperativeHandle里面 可以写多个函数
    useImperativeHandle(ref,()=>{
        return {
            _Edit(item:any){
                console.log(item)
                setIsVisible(true);
                setIsEdit(true);
                setId(item.id);
                setFileName(item.enclosure.split("").reverse().join("").split("/")[0].split("").reverse().join(""));
                setMainBody(item.enclosure);
                forms.setFieldsValue({ 
                    bidId: item.bidId, 
                    companyName: item.companyName, 
                    amount: item.amount, 
                    tenderStatus: item.tenderStatus+"", 
                    // bidType: item.bidType+"" 
                });
            },
            _Add(value2:any){
                setIsVisible(true);
            }
        }
    })

    const _addHandleCancel = (value:any) => {
        setIsVisible(value)
    }

    const onFinish = (values:any) => {
        let newValues = {
            ...values,
            enclosure: mainBody
        }
        if (!isEdit) {
            addTenderInfo({},{...newValues}).then((res:any)=> {
                if(res.code == 1000){
                    message.success('新增成功!');
                    props.propsFunc();
                    setIsVisible(false);
                    return false;
                }
                message.error(res.msg);
            }).catch((err:object) => {
                message.error("新增失败!");
            })
        }else{
            updateTenderInfo({},{...newValues,id:id}).then((res:any)=> {
                if(res.code == 1000){
                    message.success('编辑成功!');
                    props.propsFunc();
                    setIsVisible(false);
                    return false;
                }
                message.error(res.msg);
            }).catch((err:object) => {
                message.error("编辑失败!");
            })
        }
    };

    const renderForm = () => {
        const uploadOptions = {
            accept: ".pdf, .png, .jpg, .jpeg",
            showUploadList: false,
            multiple: false,
            customRequest: (res: any) => {
                if(res.file.size / 1024 / 1024 > 50 ){
                    message.error("文件不能超过50M!");
                    return false
                }

                let name = res.file.name;
                var formData = new FormData();
                formData.append("multipartFile", res.file);

                uploadFile(formData)
                .then((res:any) => {
                    if(res.code == 1000){
                        message.success('上传成功!');
                        setFileName(name);
                        setMainBody(res.data.filepath);
                        return false;
                    }
                    message.error("上传失败!");
                })
                .catch((err:any) => {
                    message.error("上传失败!");
                })
            }
        };
        const uploadButton = (
            <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
            </div>
        );

        return (
            <Form layout="horizontal" {...formItemLayout}
            form={forms}
            onFinish={onFinish}
            initialValues={{ bidId: "", companyName: "", amount: "", tenderStatus: "", bidType: "" }}
            >
                <Form.Item
                    label="招标名称"
                    name="bidId"
                    rules={[
                        {required:true,message:"请选择招标名称"},
                    ]}
                >
                    <Select
                        style={{ width: 300, marginLeft: 0 }}
                        placeholder="请选择状态"
                    >
                        {
                            dataList.length>0 && dataList.map((item:any,index:number) => {
                                return <Select.Option key={index} value={item.id}>{item.mainTitle}</Select.Option>
                            })
                        }
                    </Select>
                </Form.Item>

                <Form.Item
                    label="公司名称"
                    name="companyName"
                    rules={[
                        {required:true,message:"请输入公司名称"},
                    ]}
                >
                    <Input
                        style={{ width: 300, marginLeft: 0 }}
                        placeholder="请输入公司名称"
                        maxLength={200}
                    />
                </Form.Item>

                <Form.Item
                    label="金额"
                    name="amount"
                    rules={[
                        {required:true,message:"请输入金额"},
                    ]}
                >
                    <InputNumber 
                        maxLength={10} 
                        min={0}
                        precision={0} 
                        placeholder="请输入金额" 
                        style={{ width: 300, marginLeft: 0 }} 
                        formatter={(value:any) => `${value}元`}
                        parser={(value:any) => value!.replace('元', '')}
                    />
                </Form.Item>


                <Form.Item
                    label="状态"
                    name="tenderStatus"
                    rules={[
                        {required:true,message:"请选择状态"},
                    ]}
                >
                    <Select
                        style={{ width: 300, marginLeft: 0 }}
                        placeholder="请选择状态"
                        maxLength={200}
                    >
                        <Select.Option value="0">默认</Select.Option>
                        <Select.Option value="1">中标</Select.Option>
                        <Select.Option value="2">未中标</Select.Option>
                    </Select>
                </Form.Item>

                {/* <Form.Item
                    label="招标部门"
                    name="bidType"
                    rules={[
                        {required:true,message:"请选择招标部门"},
                    ]}
                >
                    <Select
                        style={{ width: 300, marginLeft: 0 }}
                        placeholder="请选择招标部门"
                        maxLength={200}
                    >
                        <Select.Option value="1">采购招标</Select.Option>
                        <Select.Option value="2">设计招标</Select.Option>
                        <Select.Option value="3">工程招标</Select.Option>
                    </Select>
                </Form.Item> */}

                <Form.Item label="正文附件" 
                    name="mainBody" 
                    rules={[
                        {
                            validator(rule, value) {
                                if (!mainBody) {
                                    console.log(mainBody)
                                    return Promise.reject("请上传文件");//新的form的验证回调方式
                                }
                                return Promise.resolve();
                            },
                        }
                    ]}
                >
                    <div className="uploadFilesWrap">
                        <div className="fileWrap">
                            <a href={mainBody} target="_blank">{fileName}</a>
                        </div>
                        <div className="upload">
                            <Upload {...uploadOptions} listType="picture-card">
                                {uploadButton}
                            </Upload>
                        </div>
                    </div>
                    <div style={{color:"#666666"}}>仅限pdf,png,jpg格式 50M以内</div>
                </Form.Item>

                <Form.Item
                    className="formItem"
                    {...buttonItemLayout}
                    style={{ textAlign: "right" }}
                >   
                    <Button
                        type="default"
                        onClick={() => {
                            _addHandleCancel(false);
                        }}
                    >
                        取消
                    </Button>
                    <Button style={{ marginLeft: 10 }} type="primary" htmlType="submit">保存</Button>
                </Form.Item>
            </Form>
        )
    }

    return (
        <React.Fragment>
            <Modal
                 title={isEdit?"编辑投标":"新建投标"}
                 visible={isVisible}
                 getContainer={false}
                 forceRender
                 footer={null}
                 onCancel={() => {_addHandleCancel(false)}}
                 maskClosable={false}
                 destroyOnClose
            >
                {renderForm()}
            </Modal>
        </React.Fragment>
    )
}

export default (forwardRef(FormMoudle));
